document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('form');
    const submitButton = form ? form.querySelector('input[type="submit"]') : null;

    if (submitButton && form) {
        const parentElement = submitButton.parentNode;

        const newButton = document.createElement('a');
        newButton.href = '#';
        newButton.target = '';
        newButton.className = 'btn btn-primary';
        newButton.textContent = 'Send Enquiry';

        newButton.addEventListener('click', function(e) {
            e.preventDefault();
            form.submit();
        });

        if (parentElement) {
            submitButton.remove();
            parentElement.appendChild(newButton);
        }
    }
});
